import { InterventionPreventive } from '@/models/InterventionPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { addMonths, format, subMonths } from 'date-fns';

export interface SuiviInterventionPreventiveState {
    interventions: InterventionPreventive[];

    tableHeader: TableHeader[];

    page: number;
    nbOfPages: number;
    scroll: number;
    count: number;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };

    filterStatus: Array<string>;
    filterSiteIds: Array<number>;
    filterPredictedDateFrom: string;
    filterPredictedDateTo: string;
    filterInterventionId: string;
    filterGroupeIds: Array<number>;
    filterSousGroupeIds: Array<number>;
    filterEquipementIds: Array<number>;

    isLoading: boolean;
    error?: Error;

    isExportXlsLoading: boolean;
}

export const initialState: SuiviInterventionPreventiveState = {
    interventions: [],

    tableHeader: [
        {
            label: 'intervention.id',
            sortData: 'id',
            sortStatus: SortType.NONE,
            width: '7%',
        },
        {
            label: 'dataList.chantierLibelle',
            sortData: 'adresseSite',
            sortStatus: SortType.NONE,
            width: '12%',
        },
        {
            label: 'dataList.group',
            sortData: 'groupeId',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {
            label: 'dataList.subgroup',
            sortData: 'sousGroupeId',
            sortStatus: SortType.NONE,
            width: '12%',
        },
        {
            label: 'dataList.equipment',
            sortData: 'articleClientId',
            sortStatus: SortType.NONE,
            width: '18%',
        },
        {
            label: 'intervention.request.type',
            sortData: 'type',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'label.periodicite',
            sortData: 'periodicite',
            sortStatus: SortType.INACTIVE,
            width: '5%',
        },
        {
            label: 'intervention.dateDebutPrevue',
            sortData: 'dateDebutPrevue',
            sortStatus: SortType.DESC,
            width: '6%',
        },
        {
            label: 'intervention.dateFin',
            sortData: 'dateFin',
            sortStatus: SortType.INACTIVE,
            width: '6%',
        },
        {
            label: 'intervention.request.status',
            sortData: 'etat',
            sortStatus: SortType.NONE,
            width: '4%',
            regleCle: 'suiviInterventionsPreventives.statuts',
        },
        {
            label: 'intervention.request.pdf',
            sortData: 'pdf',
            sortStatus: SortType.INACTIVE,
            width: '4%',
            regleCle: 'suiviInterventionsPreventives.rapportDisponible',
        },
    ],

    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,

    sort: {
        sortData: 'dateDebutPrevue',
        sortStatus: SortType.DESC,
    },

    filterStatus: [],
    filterPredictedDateFrom: format(subMonths(new Date(), 6), 'yyyy-MM-dd'),
    filterPredictedDateTo: format(addMonths(new Date(), 6), 'yyyy-MM-dd'),
    filterSiteIds: [],
    filterInterventionId: '',
    filterGroupeIds: [],
    filterSousGroupeIds: [],
    filterEquipementIds: [],

    isLoading: false,

    isExportXlsLoading: false,
};

export const state: SuiviInterventionPreventiveState = {
    ...initialState,
};
